module.exports = __webpack_public_path__ + "static/finance-app-cover-b8a94156c3b6c0703022b27303075c42.png";